import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { NzImageService } from "ng-zorro-antd/image";
import { MAX_PRODUCT_IMAGES, LOCAL_STORAGE, CURRENCY_ROUND } from "src/app/constants";
import { UtilityService } from "src/app/services/utility.service";
import { MessageService } from "src/app/services/message.service";
import { NzModalService } from "ng-zorro-antd/modal";

@Component( {
	selector: "app-product-details",
	templateUrl: "./product-details.component.html",
	styleUrls: [ "./product-details.component.scss" ]
} )

export class ProductDetailsComponent implements OnInit {

	@Input() productData;
	@Input() type;
	@Input() role;
	@Input() cart;
	@Input() supplierData;
	@Output() addProductToCartEvent: EventEmitter<any> = new EventEmitter();

	currentLanguage;
	images = [];
	placeholders = [];
	maxProductImages = MAX_PRODUCT_IMAGES;
	cartProducts;
	defaultCurrencySymbol = CURRENCY_ROUND.COMMON;
	originalImages = [];

	constructor(
		private translateService: TranslateService,
		private nzImageService: NzImageService,
		private utilityService: UtilityService,
		private messageService: MessageService,
		private modalService: NzModalService
	) {
		this.cartProducts = this.utilityService.getFromSessionStorage( LOCAL_STORAGE.CART );
		this.currentLanguage = this.translateService.currentLang;
		this.translateService.onLangChange.subscribe( response => {
			this.currentLanguage = response.lang;
		} );
	}

	ngOnInit(): void {
		this.prepareImages( this.productData?.files );
		this.checkForCartProducts( [ this.productData ] );
	}

	prepareImages( images ) {
		if( this.productData?.files?.length ){
			this.images = images.map( file => {
				return {
					thumbnail: file.url,
					src: file.url,
					alt: "product image"
				};
			} );

			this.originalImages = images.map( file => {
				return {
					src: file.urlOriginal
				};
			} );
		}

		const imagesCount = this.images?.length ? this.images?.length : 1;
		this.placeholders = Array( ( this.maxProductImages - imagesCount ) < 0 ? 0 : ( this.maxProductImages - imagesCount ) );
	}

	preview( index: number ): void {
		this.nzImageService.preview( this.originalImages, { nzZoom: 1.5, nzRotate: 0 } ).switchTo( index );
	}

	imageProcessing(productIndex){
		const imageProcessingPath = '../../../../assets/image-processing.jpg';
		this.images[productIndex].src = imageProcessingPath;
		this.productData.files[productIndex].url = imageProcessingPath;
		this.originalImages[productIndex].src = imageProcessingPath;
	}

	/**
	 * Handle add to cart event
	 * @param data : product data
	 */
	addProductToCart( productData ): void {
		this.cart = this.utilityService.getFromSessionStorage( LOCAL_STORAGE.CART );
		if ( !this.cart ) {
			this.utilityService.setToSessionStorage( LOCAL_STORAGE.CART, [ productData ] );
		} else {
			this.cart.push( productData );
			this.utilityService.setToSessionStorage( LOCAL_STORAGE.CART, this.cart );
		}
		this.checkForCartProducts( [ productData ] );
		this.messageService.sendMessage( { title: "cart_changed" } );
	}

	/**
	 * Check if the product is already added to the cart
	 * @param allProducts : all the products
	 */
	checkForCartProducts( allProducts ): void {
		const cartProducts = this.utilityService.getFromSessionStorage( LOCAL_STORAGE.CART );
		if ( cartProducts ) {
			cartProducts.forEach( element => {
				const index = allProducts.findIndex( data => data["id"] === element["id"] );
				if ( index !== -1 ) {
					allProducts[index].addedToCart = true;
				}
			} );
		}
	}

	addProductToTender(): void {
		this.messageService.sendMessage({ addProductToTender: this.productData });
	}

	ngOnDestroy(): void {
		this.modalService.closeAll();
	}
}
